import styled from '@emotion/styled'
import { Primary500 } from '@mehilainen/mds-customer/colors'
import React from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { getCustomerServiceNumber } from '../../services/customerService'
import { scale } from '../../utils/scale'
import { ColumnFlex } from '../Layout/Layout'
import { Text } from '../Typography/Typography'

const Container = styled(ColumnFlex)`
  ${Text} + ${Text} {
    margin-top: ${scale(2)};
  }
`

type Props = {
  callbackAllowed: boolean
}

const PractitionerBookingInstructions: React.FC<React.PropsWithChildren<Props>> = ({
  callbackAllowed,
}) => {
  const { t, i18n } = useTranslation()
  const link = getCustomerServiceNumber('general', i18n.language)
  const { label: telNumber } = link

  const callbackText = callbackAllowed
    ? t('component.practitionerBookingInstructions.callbackText')
    : ''

  return (
    <Container>
      <Text as="h2" $height="Medium" $size={500} $weight="Medium">
        {t('component.practitionerBookingInstructions.header')}
      </Text>
      <Text $height="Large">
        <Trans
          i18nKey={'component.practitionerBookingInstructions.description'}
          values={{ telNumber, callbackText }}
        >
          <Text as="a" $height="Large" $weight="Medium" $color={Primary500} href={link.link} />
        </Trans>
      </Text>
      <Text $size={300} $height="Large">
        {t('component.practitionerBookingInstructions.footnote')}
      </Text>
    </Container>
  )
}

export default PractitionerBookingInstructions
